import _ from 'lodash';
import { formatItem, formatTypes } from '../../../global/common/dateFormatting';
import { sortObject } from '../../../global/common/sorting';
import { calcMatchStatus } from './calcMatchStatus';
import { getGolfMatchInfo } from '../cnr/reducers/reducerHelpers/golfMatchHelpers';

export const calcGolfRounds = (ts, golfTournament, rounds, matches, holes, teams) => {

  const matches_rounds = {}
  const roundsStatus = {}
  const roundsStatusByHole = {}

  // sort the rounds
  const roundsSorted = sortObject(rounds, 'roundNumber')

  const total = _.sumBy(_.values(rounds), 'numberOfMatches');
  const pointsToWin = total / 2

  // create roundsStatus
  _.forEach(roundsSorted, (round, roundKey) => {

    const matches_round = matches && matches[roundKey] ? matches[roundKey] : {}

    matches_rounds[roundKey] = matches_round
    const { roundStatus, roundStatusByHole } = matches_round ? calcRound(matches_round, holes, teams) : {}

    roundsStatus[roundKey] = roundStatus
    roundsStatus[roundKey].name = round.name
    roundsStatus[roundKey].roundType = round.roundType
    roundsStatus[roundKey].handicapPercentage = round.handicapPercentage
    roundsStatus[roundKey].lowHandicapPercentage = round.lowHandicapPercentage
    roundsStatus[roundKey].golfersPerTeam = round.golfersPerTeam
    roundsStatus[roundKey].startDate = round.startDate ? formatItem(formatTypes.fullDate, round.startDate) : formatItem(formatTypes.shortDate, golfTournament.startDate)
    roundsStatus[roundKey].startTime = round.startTime ? round.startTime : 'Time'

    // options
    roundsStatus[roundKey].roundIsActive = round.roundIsActive
    roundsStatus[roundKey].roundIsDemo = round.roundIsDemo
    roundsStatus[roundKey].allowOpenScoring = round.allowOpenScoring

    roundsStatusByHole[roundKey] = roundStatusByHole
  })

  if (roundsStatus) {

    Object.keys(roundsStatus).forEach(key => {

      const rs = roundsStatus[key]

      ts.team1Wins += rs.team1Wins
      ts.team1Dormies += rs.team1Dormies
      ts.team1Leading += rs.team1Leading
      ts.team1Virtual += (rs.team1Wins + rs.team1Leading)
      ts.team1Square += rs.matchesSquare
      ts.team1Halved += rs.matchesHalved

      ts.team2Wins += rs.team2Wins
      ts.team2Dormies += rs.team2Dormies
      ts.team2Leading += rs.team2Leading
      ts.team2Virtual += (rs.team2Wins + rs.team2Leading)
      ts.team2Square += rs.matchesSquare
      ts.team2Halved += rs.matchesHalved

      ts.matchesHalved += rs.matchesHalved
    })

    ts.matchesSquare = ts.team1Square
    ts.team1Points = ts.team1Wins + (ts.team1Halved * 0.5) + (ts.team1Dormies * 0.5)
    ts.team2Points = ts.team2Wins + (ts.team2Halved * 0.5) + (ts.team2Dormies * 0.5)

    const { previousWinningTeam } = golfTournament ? golfTournament : 14

    if (parseInt(previousWinningTeam) === 1) {
      ts.team1PointsToWin = pointsToWin
      ts.team2PointsToWin = pointsToWin + .5
    } else {
      ts.team1PointsToWin = pointsToWin + .5
      ts.team2PointsToWin = pointsToWin
    }

    ts.team1PointsToNeededWin = ts.team1PointsToWin - ts.team1Points
    ts.team2PointsToNeededWin = ts.team2PointsToWin - ts.team2Points

    if (ts.team1PointsToNeededWin < 0) { ts.team1PointsToNeededWin = 0 }
    if (ts.team2PointsToNeededWin < 0) { ts.team2PointsToNeededWin = 0 }

    if (ts.team1Points >= ts.team1PointsToWin) {
      ts.tournamentWinner = teams.team1
    } else if (ts.team2Points >= ts.team2PointsToWin) {
      ts.tournamentWinner = teams.team2
    }
  }

  return { matches_rounds, roundsStatus, roundsStatusByHole }

}

const calcRound = (golfMatches, holes, teams) => {

  const roundMatchStatuses = {}
  const roundMatchStatusesByHole = {}

  let roundStatus;
  const roundStatusByHole = {};

  _.forEach(golfMatches, (gm, gmKey) => {
    const ms = calcMatchStatus(gm, holes, teams)
    const gmi = getGolfMatchInfo(gm, holes)
    const mss = {
      ...ms,
      matchLine: gmi.matchLine,
      matchLines1: gmi.matchLines1,
      matchLines2: gmi.matchLines2,
      matchLineInit: gmi.matchLineInit
    }
    roundMatchStatuses[gmKey] = mss
  })

  if (roundMatchStatuses) {
    roundStatus = ammendRoundStatus(roundMatchStatuses)
  } else {
    roundStatus = {}
  }

  if (roundMatchStatusesByHole) {
    for (var hn = 1; hn <= 18; hn++) {
      if (roundMatchStatusesByHole[hn]) {
        roundStatusByHole[hn] = ammendRoundStatus(roundMatchStatusesByHole[hn])
      }
    }
  }

  return { roundStatus, roundStatusByHole }
}

const normalizeCounts = (counts) => {
  return {
    1: counts[1] || 0,
    2: counts[2] || 0,
    3: counts[3] || 0,
    4: _.sum([
      counts[4] || 0,
      counts[5] || 0,
      counts[6] || 0,
      counts[7] || 0,
      counts[8] || 0,
      counts[9] || 0,
      counts[10] || 0
    ])
  };
};


const ammendRoundStatus = (roundMatchStatuses) => {

  const matchesFinished = _.filter(roundMatchStatuses, { finished: true })
  const matchesInProgress = _.filter(roundMatchStatuses, { finished: false })
  const matchesStarted = _.filter(roundMatchStatuses, m => m.holesScored > 0);

  const team0Wins = _.filter(matchesFinished, { leadingTeam: 0 })
  const team1Wins = _.filter(matchesFinished, { leadingTeam: 1 })
  const team2Wins = _.filter(matchesFinished, { leadingTeam: 2 })

  const team0Leading = _.filter(matchesInProgress, { leadingTeam: 0 })
  const team1Leading = _.filter(matchesInProgress, { leadingTeam: 1 })
  const team2Leading = _.filter(matchesInProgress, { leadingTeam: 2 })

  const team1LeadingCounts = _.mapValues(
    _.groupBy(team1Leading, 'leadingBy'),
    (arr) => arr.length
  );

  const team2LeadingCounts = _.mapValues(
    _.groupBy(team2Leading, 'leadingBy'),
    (arr) => arr.length
  );

  const team1Dormies = _.filter(matchesInProgress, { dormieTeam: 1 })
  const team2Dormies = _.filter(matchesInProgress, { dormieTeam: 2 })

  const roundStatus = {
    matchesTotal: Object.keys(roundMatchStatuses).length,
    matchesComplete: matchesFinished.length,
    matchesRemaining: matchesInProgress.length,
    team1Wins: team1Wins.length,
    team2Wins: team2Wins.length,
    team1Dormies: team1Dormies.length,
    team2Dormies: team2Dormies.length,
    team1Leading: team1Leading.length,
    team2Leading: team2Leading.length,
    matchesHalved: team0Wins.length,
    matchesSquare: team0Leading.length,
    matchStatuses: roundMatchStatuses,
    team1Points: 0,
    team2Points: 0,
    leadingCounts: {
      team1LeadingCounts: normalizeCounts(team1LeadingCounts),
      team2LeadingCounts: normalizeCounts(team2LeadingCounts),
    },
    matchesStarted: 0,
    roundStarted: false
  }

  roundStatus.team1Points = roundStatus.team1Wins + (roundStatus.matchesHalved * 0.5) + (roundStatus.team1Dormies * 0.5)
  roundStatus.team1Halved = roundStatus.matchesHalved
  roundStatus.team2Points = roundStatus.team2Wins + (roundStatus.matchesHalved * 0.5) + (roundStatus.team2Dormies * 0.5)
  roundStatus.team2Halved = roundStatus.matchesHalved
  roundStatus.roundStarted = _.size(matchesStarted) > 0
  roundStatus.matchesStarted = _.size(matchesStarted)
  roundStatus.roundComplete = roundStatus.matchesTotal > 0 && (roundStatus.matchesTotal === roundStatus.matchesComplete) ? true : false
  roundStatus.roundStrokeInfo = calcStrokeInfo(roundStatus)

  return roundStatus
}

const calcStrokeInfo = (roundStatus) => {

  if (roundStatus) {
    const round_ss = {
      strokingAdvantage1: 0,
      strokingAdvantage2: 0,
      strokingDisadvantage1: 0,
      strokingDisadvantage2: 0,
      strokesNone: 0,
      strokesEven: 0,
      strokingDiff: 0,
    }

    const hole_ss = {}

    const { matchStatuses } = roundStatus ?? {}

    if (matchStatuses) {
      // loop the matchStatuses
      Object.keys(matchStatuses).forEach(msk => {
        const matchStatus = matchStatuses[msk]
        const { holeStrokesStatus } = matchStatus ? matchStatus : {}
        const { holeStrokes } = holeStrokesStatus ? holeStrokesStatus : {}
        if (holeStrokes) {
          for (var holeNumber = 1; holeNumber <= 18; holeNumber++) {
            const holeStroke = holeStrokes[holeNumber]
            const { strokingAdvantage1, strokingAdvantage2, strokingDisadvantage1, strokingDisadvantage2, strokesNone, strokesEven } = holeStroke ? holeStroke : {}
            round_ss.strokingAdvantage1 += strokingAdvantage1
            round_ss.strokingAdvantage2 += strokingAdvantage2
            round_ss.strokingDisadvantage1 += strokingDisadvantage1
            round_ss.strokingDisadvantage2 += strokingDisadvantage2
            round_ss.strokesNone += strokesNone
            round_ss.strokesEven += strokesEven
            round_ss.strokingDiff += (strokingAdvantage1 + strokingAdvantage1) - (strokingDisadvantage1 + strokingDisadvantage2)

            if (!hole_ss[holeNumber]) { hole_ss[holeNumber] = _.cloneDeep(round_ss) }
            hole_ss[holeNumber].strokingAdvantage1 += strokingAdvantage1
            hole_ss[holeNumber].strokingAdvantage2 += strokingAdvantage2
            hole_ss[holeNumber].strokingDisadvantage1 += strokingDisadvantage1
            hole_ss[holeNumber].strokingDisadvantage2 += strokingDisadvantage2
            hole_ss[holeNumber].strokesNone += strokesNone
            hole_ss[holeNumber].strokesEven += strokesEven
            hole_ss[holeNumber].strokingDiff += (strokingAdvantage1 + strokingAdvantage1) - (strokingDisadvantage1 + strokingDisadvantage2)

          }
        }
      })

      return { round_ss, hole_ss }
    }


  }


}